import React from 'react';

/*
  Attractive reorderable thumbnail grid used by the Add/Edit product forms.
  Position 0 is the "Main" thumbnail. Move with ◀ ▶, remove with ✕.
*/
function ImageReorderGrid({ images, onMove, onRemove, onEdit }) {
  if (!images || images.length === 0) return null;

  return (
    <div className="irg-wrap">
      {images.map((src, i) => (
        <div className={`irg-thumb ${i === 0 ? 'irg-main' : ''}`} key={i}>
          <div className="irg-imgbox">
            <img src={src} alt={`Product ${i + 1}`} className="irg-img" />

            {i === 0 && <span className="irg-badge">★ Main</span>}
            <span className="irg-pos">{i + 1}</span>

            <button
              type="button"
              className="irg-remove"
              onClick={() => onRemove(i)}
              title="Remove image"
            >
              ✕
            </button>
          </div>

          <div className="irg-ctrl">
            <button
              type="button"
              className="irg-move"
              onClick={() => onMove(i, i - 1)}
              disabled={i === 0}
              title="Move left"
            >
              ◀
            </button>
            {onEdit && (
              <button
                type="button"
                className="irg-move irg-crop"
                onClick={() => onEdit(i)}
                title="Crop / adjust"
              >
                ✂
              </button>
            )}
            <button
              type="button"
              className="irg-move"
              onClick={() => onMove(i, i + 1)}
              disabled={i === images.length - 1}
              title="Move right"
            >
              ▶
            </button>
          </div>
        </div>
      ))}

      <style>{irgStyles}</style>
    </div>
  );
}

const irgStyles = `
  .irg-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-bottom: 8px;
  }
  .irg-thumb {
    width: 112px;
    padding: 6px;
    border-radius: 16px;
    background: #fff;
    border: 1px solid #f1f5f9;
    box-shadow: 0 4px 14px rgba(0,0,0,0.06);
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  }
  .irg-thumb:hover {
    transform: translateY(-4px);
    box-shadow: 0 14px 26px rgba(194,65,12,0.16);
  }
  .irg-main {
    border: 2px solid #ea580c;
    box-shadow: 0 10px 24px rgba(234,88,12,0.25);
  }

  .irg-imgbox {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
  }
  .irg-img {
    width: 100%;
    height: 104px;
    object-fit: cover;
    display: block;
  }

  .irg-badge {
    position: absolute;
    top: 6px;
    left: 6px;
    background: linear-gradient(135deg, #ea580c, #f59e0b);
    color: #fff;
    font-size: 0.62rem;
    font-weight: 700;
    padding: 3px 9px;
    border-radius: 20px;
    box-shadow: 0 3px 8px rgba(234,88,12,0.4);
  }
  .irg-pos {
    position: absolute;
    bottom: 6px;
    left: 6px;
    width: 19px;
    height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(15,23,42,0.7);
    color: #fff;
    font-size: 0.62rem;
    font-weight: 700;
    border-radius: 50%;
  }
  .irg-remove {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 22px;
    height: 22px;
    line-height: 1;
    border: none;
    border-radius: 50%;
    background: rgba(220,38,38,0.92);
    color: #fff;
    font-size: 0.72rem;
    cursor: pointer;
    opacity: 0;
    transform: scale(0.8);
    transition: opacity 0.2s ease, transform 0.2s ease;
  }
  .irg-thumb:hover .irg-remove {
    opacity: 1;
    transform: scale(1);
  }

  .irg-ctrl {
    display: flex;
    justify-content: center;
    gap: 6px;
    margin-top: 7px;
  }
  .irg-move {
    width: 32px;
    height: 26px;
    border: none;
    border-radius: 8px;
    background: #fff7ed;
    color: #c2410c;
    font-size: 0.7rem;
    cursor: pointer;
    transition: background 0.15s ease, transform 0.15s ease;
  }
  .irg-move:hover:not(:disabled) {
    background: #ffedd5;
    transform: translateY(-1px);
  }
  .irg-move:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
  .irg-crop {
    background: #ecfdf5;
    color: #16a34a;
  }
  .irg-crop:hover {
    background: #d1fae5;
  }

  /* touch devices: remove button always visible */
  @media (hover: none) {
    .irg-remove { opacity: 1; transform: scale(1); }
  }
`;

export default ImageReorderGrid;
